import { useEffect } from 'react';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { IAdminxStore } from '../../stores';

export const useCampaignWebappsCidOptions = (enabled: boolean) => {
	const { webappsCidStore } = useStores<IAdminxStore>();
	const listStore = webappsCidStore.listStore;

	useEffect(() => {
		if (!enabled) {
			return;
		}

		listStore.fetch();
	}, [enabled, listStore]);

	return {
		cids: listStore.getList(),
		isLoading: enabled && listStore.getIsLoading(),
	};
};
